
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 *  The base for every action. An action is a clickable
 *  icon that emits the click action, allowing users
 *  to invoke a specific action.
 */
@Component
export default class ActionBase extends Vue {

    @Prop({ type: String, required: true })
    private title!: string;

}
